export const getCleanUrl = (url?: string): string => {
  if (!url) return '';

  if (url.startsWith('https://') || url.startsWith('http://')) return url.trim();

  return `//${url.replace('www.', '').trim()}`;
};
